export type AddressParts = {
  address?: string | null;
  cap?: string | null;
  city?: string | null;
  province?: string | null;
};

const normalizePart = (value?: string | null): string | undefined => {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed.length ? trimmed : undefined;
};

export function formatAddressParts(parts: AddressParts): string | undefined {
  const address = normalizePart(parts.address);
  const cap = normalizePart(parts.cap);
  const city = normalizePart(parts.city);
  const province = normalizePart(parts.province);

  const locality = [cap, city].filter(Boolean).join(' ');
  const provinceSuffix = province ? `(${province})` : undefined;
  const localityLine = [locality, provinceSuffix].filter(Boolean).join(' ');

  const segments = [address, localityLine].filter(Boolean);
  return segments.length ? segments.join(', ') : undefined;
}

export function resolveAddress(parts: AddressParts, fallback?: string | null): string | undefined {
  return formatAddressParts(parts) ?? normalizePart(fallback);
}
